<template>
    <div id="image-modal-container" v-if="data" @click="closeModal">
      <div id="image-modal-content">
        <img id="image-modal" :src="data.imageURL">
      </div>
      <div id="closeButtonContainer" class="button">
        <div id="closeButton">[close]</div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'ImageModal',
  props: {
    data: Object
  },
  mounted() {},
  data: function (){
    return {
      ready: false,
      desiredMasks: [{type: null, size: null}]
    }
  },
  methods: {
    closeModal() {
      this.$store.commit('setImageModal')
    },
  },
  computed: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.modal-scrollable {
  // overflow-y: auto;
  // height: 80%;
}
.mask-settings {
  // padding: 2px 0;
  // margin: 2px auto;
  // display: inlne-block;
}
.mask-option-group {
  // border: 1px solid white;
  // display: inline-block;
  // text-align: center;
  // padding: 5px;
}
#image-modal-container {

    position: fixed;
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
}
#image-modal-content{
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
  z-index: 25;
}
#image-modal {
  width: 100%;
  overflow: auto;
  margin: auto;
  position: absolute;
  top: 0; left: 0; bottom: 0; right: 0;
  border: solid black;
}
#closeButtonContainer {
  position: absolute;
  bottom: 50px;
  width: 100%;
  text-align: center;
  #closeButton {
    font-weight: bold;
    font-size: 20px;
    border-radius: 5px;
    padding: 10px;
    width: 100px;
    margin: auto;
    color: $oroGold;
    background: black;
  }
}
</style>
